import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFDA44",
      d: "M.498 10.783a8.003 8.003 0 0 0 15.005 0L8 10.087z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M8 0A8 8 0 0 0 .498 5.217L8 5.913l7.502-.696A8 8 0 0 0 8 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M.498 5.217A8 8 0 0 0 0 8c0 .979.176 1.916.498 2.783h15.005A8 8 0 0 0 16 8c0-.979-.176-1.916-.498-2.783z"
    }, null, -1)
  ])))
}
export default { render: render }